/***********************************************************************************/
/* SECTION: s2w-popup.liquid & s2w-popup-2yw.liquid                                */
/***********************************************************************************/

// Toast: error
function showErrorToast(message, timeout = 3000) {
  const toast = document.createElement('div');
  toast.className = 'toast-block';
  toast.textContent = message;

  document.body.appendChild(toast);

  setTimeout(() => {
    toast.classList.add('show');
    toast.classList.remove('hide');
  }, 100);

  setTimeout(() => {
    toast.classList.add('hide');
    toast.classList.remove('show');
    setTimeout(() => {
      document.body.removeChild(toast);
    }, 500);
  }, timeout);
}

/* Scan 2 Win - Generic Popup */

function s2wCloseModalAndCleanURL(modal) {
  // Close the modal
  modal.style.display = 'none';

  // Get the current URL
  const url = new URL(window.location.href);

  // Remove the 'sku' and 'brand' query parameters
  url.searchParams.delete('sku');
  url.searchParams.delete('brand');

  // Update the URL without reloading the page
  window.history.replaceState({}, document.title, url.toString());
}

function initS2wModal() {
  // Disabled with the bootstrap call below; see the note there. Kept rather
  // than deleted so the old flow is easy to restore or consult.
  return;
  // eslint-disable-next-line no-unreachable
  const modal = document.getElementById('scanToWinModal');
  if (!modal) return;

  const form = modal.getElementsByTagName('form')[0];
  const emailInput = modal.getElementsByTagName('input')[0];
  const errorMessage = modal.getElementsByClassName('error-message')[0];
  const closeButton = modal.getElementsByClassName('modal-close-button')[0];

  // Close the modal when the close button or overlay is clicked
  closeButton.addEventListener('click', function () {
    s2wCloseModalAndCleanURL(modal);
  });

  modal.addEventListener('click', function (event) {
    if (event.target === modal) {
      s2wCloseModalAndCleanURL(modal);
    }
  });

  // SCAN2WIN: Event handler
  if (window.location.search.includes('brand=') && window.location.search.includes('sku=')) {
    const sku = new URLSearchParams(window.location.search).get('sku');
    if ((sku || '').toUpperCase() === 'HWT') {
      return;
    }

    modal.style.display = 'flex';

    form.addEventListener('submit', async function (event) {
      event.preventDefault();

      const emailValue = emailInput.value;
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailPattern.test(emailValue)) {
        errorMessage.style.opacity = '1';
        return;
      } else {
        errorMessage.style.opacity = '0';
      }

      const button = form.querySelector('.modal-info-block-button');
      button.disabled = true;
      button.innerHTML = '<span class="spinner"></span>';

      const sku = new URLSearchParams(window.location.search).get('sku');
      try {
        const response = await fetch('https://api.halio-sonic.com/v1/recipients', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            recipient: {
              contact: emailValue,
              short_code: sku,
            },
          }),
        });

        const result = await response.json();

        if (result.success) {
          const title = form.querySelector('.modal-info-block-title');
          const subtitle = form.querySelector('.modal-info-block-subtitle');
          if (result.already_participated) {
            title.textContent = 'You are already registered!';
            subtitle.textContent = '';
          } else {
            title.textContent = "You're on the list!";
            subtitle.textContent = 'Hang on tight! Our team will be in touch soon.';
          }

          form.querySelectorAll('input, button, .modal-info-block-hint').forEach((el) => (el.style.display = 'none'));
        } else {
          showErrorToast(
            result.error ||
              "We couldn't connect you with the server this time. Let's check if you are connected to the internet!"
          );
        }
      } catch (error) {
        showErrorToast(
          "We couldn't connect you with the server this time. Let's check if you are connected to the internet!"
        );
      } finally {
        button.disabled = false;
        button.innerHTML = 'GET LUCKY!';
      }
    });
  }
}

/* Scan 2 Win - 2 Year Warranty */

function tywCloseModalAndCleanURL(modal) {
  // Close the modal
  modal.style.display = 'none';

  // Get the current URL
  const url = new URL(window.location.href);

  // Remove the 'sku' and 'brand' query parameters
  url.searchParams.delete('sku');
  url.searchParams.delete('brand');

  // Update the URL without reloading the page
  window.history.replaceState({}, document.title, url.toString());
}

function initTywModal() {
  const modal = document.getElementById('scanToWinModal-tyw');
  if (!modal) return;

  const form = modal.getElementsByTagName('form')[0];
  const emailInput = modal.getElementsByTagName('input')[0];
  const errorMessage = modal.getElementsByClassName('error-message')[0];
  const closeButton = modal.getElementsByClassName('modal-close-button')[0];

  // Close the modal when the close button or overlay is clicked
  closeButton.addEventListener('click', function () {
    tywCloseModalAndCleanURL(modal);
  });

  modal.addEventListener('click', function (event) {
    if (event.target === modal) {
      tywCloseModalAndCleanURL(modal);
    }
  });

  // SCAN2WIN: Event handler
  if (window.location.search.includes('brand=') && window.location.search.includes('sku=')) {
    const sku = new URLSearchParams(window.location.search).get('sku');
    if ((sku || '').toUpperCase() !== 'HWT') {
      return;
    }

    modal.style.display = 'flex';

    form.addEventListener('submit', async function (event) {
      event.preventDefault();

      const emailValue = emailInput.value;
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailPattern.test(emailValue)) {
        errorMessage.style.opacity = '1';
        return;
      } else {
        errorMessage.style.opacity = '0';
      }

      const button = form.querySelector('.modal-info-block-button');
      button.disabled = true;
      button.innerHTML = '<span class="spinner"></span>';

      const sku = new URLSearchParams(window.location.search).get('sku');
      try {
        const response = await fetch('https://api.halio-sonic.com/v1/recipients', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            recipient: {
              contact: emailValue,
              short_code: sku,
            },
          }),
        });

        const result = await response.json();

        if (result.success) {
          const title = form.querySelector('.modal-info-block-title');
          const subtitle = form.querySelector('.modal-info-block-subtitle');
          if (result.already_participated) {
            title.textContent = 'You are already registered!';
            subtitle.textContent = '';
          } else {
            title.textContent = 'Success! Your extended warranty has been claimed';
            subtitle.textContent = 'Your Halio toothbrush is protected for the long run';
          }

          form.querySelectorAll('input, button, .modal-info-block-hint').forEach((el) => (el.style.display = 'none'));
        } else {
          showErrorToast(
            result.error ||
              "We couldn't connect you with the server this time. Let's check if you are connected to the internet!"
          );
        }
      } catch (error) {
        showErrorToast(
          "We couldn't connect you with the server this time. Let's check if you are connected to the internet!"
        );
      } finally {
        button.disabled = false;
        button.innerHTML = 'CLAIM IT NOW';
      }
    });
  }
}

/* Bootstrap Scan2Win Functionality */
/*
 * initS2wModal is disabled. The scan flow now lives on the Scan to Win landing
 * page (page.scan-to-win.json), which the QR codes point at, so this modal was
 * opening on top of it whenever a scan arrived with ?brand=&sku=. Its close
 * handler also deletes sku from the URL, and the lander reads that param to
 * tag the signup, so leaving it running could drop the SKU tag.
 *
 * initTywModal is NOT disabled: it only fires for sku=HWT and offers the
 * 2-year toothbrush warranty, which is a separate flow the lander does not
 * cover. The function below is left in place for that reason.
 */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    // initS2wModal();
    initTywModal();
  });
} else {
  // initS2wModal();
  initTywModal();
}
